// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { WelcomeModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class WelcomeBaseService {
  protected _welcomeModel$: BehaviorSubject<WelcomeModel | null>;
  get welcomeModel$(): Observable<WelcomeModel | null> {
    return this._welcomeModel$;
  }

  constructor() {
    this._welcomeModel$ = new BehaviorSubject<WelcomeModel | null>(null);
  }

  public abstract loadData(campaignId: string): void;
}
